import React, { useEffect, useState } from 'react';



const Api = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	
	/* useEffect(() => {
		fetch(`https://randomuser.me/api/?results=500`)
		.then((response) => {
			if (!response.ok) {
				throw new Error(
				`This is an HTTP error: The status is ${response.status}`
				);
			}
			return response.json();
		})
		.then((actualData) => {
			//setData(actualData);
			setData(actualData['results']);
			console.log(actualData);
			setError(null);
		})
		.catch((err) => {
			setError(err.message);
			setData(null);
		})
		.finally(() => {
			setLoading(false);
		});
	}, []); */
	
	useEffect(() => {
		const getData = async () => {
			try {
				const response = await fetch(
					`https://p1.squareoffnow.com/api/puzzle?playerid=5467253910798336&forLeaderboard=1`
				);
				if (!response.ok) {
					throw new Error(
					`This is an HTTP error: The status is ${response.status}`
					);
				}
				let actualData = await response.json();
				//setData(actualData);
				setData(actualData);
				console.log(actualData);
				console.log(actualData.leaderboard);
				setError(null);
			} catch(err) {
			setError(err.message);
			setData(null);
			} finally {
				setLoading(false);
			}  
		}
		getData()
	}, []);
	
	return (
		<div className="api-overlay">
			{loading && <div>A moment please...</div>}
			{error && (
				<div>{`There is a problem fetching the post data - ${error}`}</div>
			)}
			{data && data.leaderboard.map((user) => (
				<div key={user.reward.seasonRank} className="api-box">
					<h2>Name : {user.displayName}</h2>
					<h2>Season Rank : {user.reward.seasonRank}</h2>
					<h2>Diamonds : {user.reward.diamonds}</h2>
					<h2>Country : {user.country}</h2>
					<h2>Elo : {user.elo}</h2>
					<h2>Points : {user.points}</h2>
					<h2>Best Score : {user.best_score}</h2>
				</div>
			))}
		</div>
	);

}

export default Api;